// API Configuration — normalized (no trailing slash) so joins like `${API_URL}/auth/login` are stable.
const _rawApiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8000').trim();
export const API_URL = _rawApiUrl.replace(/\/+$/, '');

// Helper function to get full API endpoint URL
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};
